<template>

  <div class="container">

    <div class="handle-box-search">

      <el-row class="head-search">
        <el-col :span="8">
          <span class="title">标题:</span>
          <!-- 搜索司机名称-->
          <el-input v-model="search_data.keywords" placeholder="请输入标题 " class="handle-input mr10" @keyup.enter.native="searchHeplLists"></el-input>
        </el-col>

      </el-row>



      <el-row class="head-search">

        <el-col :span="24" style="margin: 10px 0;">
          <span class="title">端口:</span>
          <el-radio-group v-model="search_data.port" size="small">
            <el-radio label="" border>
              全部</el-radio>
            <el-radio v-for="(item, index) in val_port_array" :key="index" :label="String(item.val)" border>
              {{ item.alias }}</el-radio>
          </el-radio-group>
        </el-col>

      </el-row>



      <el-button type="primary" icon="el-icon-search" @click="searchHeplLists">搜索</el-button>
      <el-button @click="add_isShow=!add_isShow">添加</el-button>
      <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>





    </div>

    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header"
      @selection-change="handleSelectionChange">

      <el-table-column type="selection" width="55" align="center" prop="help_code"></el-table-column>
      <el-table-column type="expand">
        <template slot-scope="props">

          <!-- 表格下拉 -->

          <div>
            <span style="font-size: 14px;">关键字:</span>
            <span v-for="(item, index) in props.row.key_synchronization"
              style="margin-right: 5px;font-size: 14px;">{{ item }}</span>
          </div>


        </template>
      </el-table-column>





      <el-table-column prop="id" label="id" width="80">
      </el-table-column>

      <el-table-column prop="title" label="标题">
      </el-table-column>

      <el-table-column prop="port.alias" label="端口">
      </el-table-column>


      <el-table-column prop="name" label="所属城市" width="300">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <p>城市编码: {{ scope.row.city.city_code }}</p>
            <div slot="reference">
              <el-tag size="medium" style="border:0;background-color:#FFF;color:#333">{{ scope.row.city.name }}</el-tag>
            </div>
          </el-popover>
        </template>
      </el-table-column>



      <el-table-column prop="time.YmdHis" label="创建时间">
      </el-table-column>

      <el-table-column label="操作" width="150">
        <template slot-scope="scope">

          <el-button type="primary" @click="edit_isShow = !edit_isShow; help_children = scope.row.help_code;">

            编辑

          </el-button>

        </template>
      </el-table-column>



    </el-table>
    <el-button type="primary" icon="el-icon-delete" class="handle-del mr10" @click="deleteData"
    style="margin-top: 20px;">批量删除</el-button>
    <!-- 分页组件 -->
    <div class="pagination">
      <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
    </div>

    <!-- 添加组件 -->
    <addHelp :isShow="add_isShow" @onSubmit="heplLists"></addHelp>

     <!-- 添加组件 -->
     <editHelp :isShow="edit_isShow" :data="help_children" @onSubmit="heplLists"></editHelp>


  </div>

</template>

<script>
  var _this;
  import addHelp from './addHelp.vue';
  import editHelp from './editHelp.vue';
  export default {
    components: {
      addHelp,
      editHelp
    },
    data() {
      return {

        add_isShow:false,

        edit_isShow:false,

        help_children:'',

        // 批量删除
        delDriverSubmit_data: {
          help_code_array: []
        },
        delDriverSubmit_rules: {
          help_code_array: {
            placeholder: '权限模块',
            rules: {
              required: false,
              message: '权限模块代码数组(json)',
              regulation: 'special',
              rulesData: 'json_array'
            }
          }
        },

        // 下拉搜索城市
        value_city_code: '',
        options_city_code: [],
        city_options_data: {
          page: 1,
          limit: 50,
          name: ''
        },
        company_name: '',

        val_port_array: '',


        // 存放表格数据
        tableData: [],

        //翻页数据
        search_data: {
          page: 1,
          limit: 10,
          city_code: '',
          port: '',
          keywords: ''
        },

        result_data: [],
        search_rules: {
          page: {
            placeholder: '页码',
            rules: {
              required: true,
              message: '页码需要大于0',
              regulation: 'gt',
              rulesData: 0
            }
          },
          limit: {
            placeholder: '每页个数',
            rules: {
              required: true,
              message: '每页个数需在1-51之内',
              regulation: 'between',
              rulesData: [1, 51]
            }
          },

        },
      };
    },
    created() {
      _this = this;
      _this.heplLists();
    },

    methods: {
      searchHeplLists(){
        _this.search_data.page = 1;
        _this.heplLists();
      },
      cityChange(val) {

        _this.search_data.city_code = val;
        if (val != '') {

          _this.$post(
            "/city/getCityDetails", {
              city_code: val
            }
          ).then(res => {

            _this.company_name = res.data.company.name;

          }).catch((err) => {

          })

        } else {
          _this.company_name = '';
        }



      },
      //搜索的下拉框弹出触发
      cityVisibleChange(val) {
        if (val && _this.options_city_code.length < 1) {
          // 请求公司管理接口获取公司唯一编码
          _this.$post(
            "/city/cityLists",
            _this.city_options_data
          ).then(res => {
            _this.options_city_code = res.data

          }).catch((err) => {

          })
        }

      },


      // 搜索司机审核列表
      heplLists() {
        _this.$post(
            "/help/helpLists",
            _this.search_data,
            _this.search_rules
          )
          .then(res => {

            // 将请求的数据存放到表格数据数组中
            _this.tableData = res.data;
            _this.result_data = res;

            _this.val_port_array = _this.tableData[0].port.select_array;
          }).catch((err) => {

          })
      },
      //翻页组件的回调
      pages_function(search_data) {

        //赋值
        _this.search_data = search_data;
        //初始化列表
        _this.heplLists();

      },

      handleSelectionChange(val) {

        var datalist = [];

        for (var i in val) {

          datalist.push(val[i].help_code);

        }
        _this.delDriverSubmit_data.help_code_array = datalist;
      },
      // 批量删除
      deleteData() {

        if (_this.delDriverSubmit_data.help_code_array.length == 0) {

          _this.$message.warning('请至少勾选一条数据');

          return;
        }


        _this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {

          confirmButtonText: '确定',

          cancelButtonText: '取消',

          type: 'warning',

        }).then(() => {
          _this.delDriverSubmit_data.help_code_array = JSON.stringify(_this.delDriverSubmit_data
            .help_code_array);

          _this.$post(
              "/help/delHelpSubmit",
              _this.delDriverSubmit_data,
              _this.delDriverSubmit_rules
            )
            .then(res => {

              _this.$message.success('删除成功!');

              //初始化显示列表
              _this.heplLists();

            }).catch((err) => {

            })

        }).catch(() => {

          _this.$message.info('已取消删除');

        });


      },

      // 刷新按钮
      refresh() {
        this.$router.go(0);
      },
    }
  };
</script>

<style scoped>
  .handle-box {
    margin-bottom: 20px;
  }

  .handle-select {
    width: 120px;
  }

  .handle-input {
    width: 200px;
    display: inline-block;
  }

  .table {
    width: 100%;
    font-size: 14px;
  }

  .red {
    color: #ff0000;
  }

  .mr10 {
    margin-right: 10px;
  }

  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }

  .el-table__row {
    height: 100px;
  }

  .el-form-item.el-form-item--small {
    width: 100%;
  }

  .demo-table-expand {
    font-size: 0;
  }

  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }

  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
  }

  .el-form-item__content span {
    display: inline-block;
    width: 100%;
    word-wrap: break-word;
    white-space: normal;
  }
</style>